import { css } from "@linaria/core";

export const screenreaderOnly = css`
  position: absolute;
  top: auto;
  left: -10000px;

  height: 1px;
  width: 1px;

  overflow: hidden;
`
